import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import logo from "../../images/logo.png";
import LoginImage from "../../images/cap-login-avatar-image.png";
import IntlMessages from "../../services/intlMesseges";
import * as userActions from "../../redux/actions/user-actions";
import * as OrgActions from "../../redux/actions/organization-actions";
import { notifyUser } from "../../services/notification-service";
import { Spin } from "antd";
import { Checkbox } from 'antd';
import UserRoles from "../../user-roles";
import QRCode from "qrcode.react";

class Login extends Component {
  constructor(props) {
    super(props);
    if (window.performance) {
      if (performance.navigation.type === 1) {
        //this.unsetTempData();
      }
    }
    this.state = {
      email: localStorage.getItem("email_submitted") || "",
      password: localStorage.getItem("password_submitted") || "",
      remember_me: false,
      submitted: false,
      // MFA state
      mfaStep: null,        // null | 'setup' | 'verify'
      mfaMethod: 'QR',     // 'QR' | 'EMAIL'
      tempToken: "",
      mfaUserId: "",
      secretKey: "",
      qrUrl: "",
      otpCode: ["", "", "", "", "", ""],
      mfaLoading: false,
      emailOtpSent: false,
      resendCooldown: 0,    // seconds remaining before resend is enabled
    };
    this.signIn = this.signIn.bind(this);
    this.otpRefs = [];
  }

  componentDidMount() {
    

    if (this.props.isLoggedIn === true) {
      this.props.history.push(JSON.parse(localStorage.getItem("user")).redirect);
    } else {
      let isRemember = localStorage.getItem("remember_me") || this.state.remember_me;
      if(isRemember == "false"){
        localStorage.clear();
      }
      /* let loggedInUser = localStorage.getItem("user");
      loggedInUser = (loggedInUser != "") ? JSON.parse(localStorage.getItem("user")) : null;
      if(loggedInUser !== null){
        this.props.history.push(UserRoles.types[loggedInUser.role].url);
      } */
      this.emailInput.focus();
    };
  }

  handleChange = e => {
    this.setState({ loginMessage: "" });
    const { name, value } = e.target;
    if(e.target.type === "checkbox"){
      this.setState({ [name]: e.target.checked });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ submitted: true });
    const { email, password, remember_me } = this.state;
    this.setTempData(email, password, remember_me);
    if (email && password) {
      this.signIn(email, password);
    } else {
      notifyUser("Please enter the details.", "error");
      this.setState({ submitted: false });
    }
  };

  signIn = async (email, password) => {
    const result = await this.props.login(email, password);
    

    // Check for MFA responses
    if (result && result.mfaStep === 'setup') {
      // MFA setup required — fetch QR code
      this.setState({
        mfaStep: 'setup',
        mfaMethod: result.mfaMethod || 'QR',
        tempToken: result.tempToken,
        mfaUserId: result.userId,
        submitted: false,
        mfaLoading: true
      });
      const setupResult = await this.props.mfaSetup(result.tempToken, result.userId);
      if (setupResult && !setupResult.error) {
        this.setState({
          secretKey: setupResult.secretKey || "",
          qrUrl: setupResult.qrUrl || "",
          mfaLoading: false
        });
      } else {
        this.setState({ mfaLoading: false });
      }
      return;
    }

    if (result && result.mfaStep === 'verify') {
      const mfaMethod = (result.mfaMethod || 'QR').toUpperCase();
      // MFA already set up — show OTP input
      this.setState({
        mfaStep: 'verify',
        mfaMethod: mfaMethod,
        tempToken: result.tempToken,
        mfaUserId: result.userId,
        submitted: false
      });
      // If method is EMAIL, auto-send the OTP immediately
      if (mfaMethod === 'EMAIL' || result.nextAction === 'SEND_EMAIL_OTP') {
        this.handleSendEmailOtp(result.tempToken, result.userId);
      }
      return;
    }

    // Normal login flow (no MFA)
    if (this.props.redirect && this.props.redirect !== "") {
      this.props.cleanDivisionsTree();
      this.unsetTempData();
      this.props.history.push(this.props.redirect, { isLoggedIn: true });
    } else {
      this.setState({ submitted: false });
    }
  };

  // OTP input handlers
  handleOtpChange = (index, value) => {
    if (value.length > 1) {
      value = value.slice(-1);
    }
    if (value && !/^\d$/.test(value)) return;

    const otpCode = [...this.state.otpCode];
    otpCode[index] = value;
    this.setState({ otpCode: otpCode });

    // Auto-focus next input
    if (value && index < 5 && this.otpRefs[index + 1]) {
      this.otpRefs[index + 1].focus();
    }
  };

  handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !this.state.otpCode[index] && index > 0) {
      if (this.otpRefs[index - 1]) {
        this.otpRefs[index - 1].focus();
      }
    }
  };

  handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      const otpCode = pastedData.split("");
      this.setState({ otpCode: otpCode }, () => {
        if (this.otpRefs[5]) {
          this.otpRefs[5].focus();
        }
      });
    }
  };

  handleMfaSubmit = async (e) => {
    e.preventDefault();
    const otp = this.state.otpCode.join("");
    if (otp.length !== 6) {
      notifyUser("Please enter a valid 6-digit OTP.", "error");
      return;
    }

    this.setState({ mfaLoading: true });
    const result = await this.props.mfaVerifyOtp(
      this.state.tempToken,
      this.state.mfaUserId,
      otp
    );

    if (result && result.success) {
      // Login completed by the action — navigate
      this.unsetTempData();
      if (this.props.redirect && this.props.redirect !== "") {
        this.props.cleanDivisionsTree();
        this.props.history.push(this.props.redirect, { isLoggedIn: true });
      }
    } else {
      this.setState({ mfaLoading: false, otpCode: ["", "", "", "", "", ""] });
      if (this.otpRefs[0]) {
        this.otpRefs[0].focus();
      }
    }
  };

  handleBackToLogin = () => {
    // Clear resend cooldown timer if active
    if (this._resendTimer) {
      clearInterval(this._resendTimer);
      this._resendTimer = null;
    }
    this.setState({
      mfaStep: null,
      mfaMethod: 'QR',
      tempToken: "",
      mfaUserId: "",
      secretKey: "",
      qrUrl: "",
      otpCode: ["", "", "", "", "", ""],
      mfaLoading: false,
      emailOtpSent: false,
      resendCooldown: 0,
      submitted: false
    });
  };

  setTempData = (email, password, remember_me) => {
    localStorage.setItem("email_submitted", email);
    localStorage.setItem("password_submitted", password);
    localStorage.setItem("remember_me", remember_me);
  };

  handleSendEmailOtp = async (tempToken, userId) => {
    const token = tempToken || this.state.tempToken;
    const uid = userId || this.state.mfaUserId;
    this.setState({ emailOtpSent: true, resendCooldown: 60 });
    await this.props.mfaSendEmailOtp(token, uid);
    // Start 60-second countdown
    if (this._resendTimer) clearInterval(this._resendTimer);
    this._resendTimer = setInterval(() => {
      this.setState(prev => {
        if (prev.resendCooldown <= 1) {
          clearInterval(this._resendTimer);
          this._resendTimer = null;
          return { resendCooldown: 0 };
        }
        return { resendCooldown: prev.resendCooldown - 1 };
      });
    }, 1000);
  };

  componentWillUnmount() {
    if (this._resendTimer) clearInterval(this._resendTimer);
  }
  unsetTempData = () => {
    localStorage.removeItem("email_submitted");
    localStorage.removeItem("password_submitted");
    //localStorage.removeItem("remember_me");
  };

  renderOtpInputs() {
    return (
      <div className="otp-inputs">
        {this.state.otpCode.map((digit, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            maxLength="1"
            value={digit}
            onChange={(e) => this.handleOtpChange(index, e.target.value)}
            onKeyDown={(e) => this.handleOtpKeyDown(index, e)}
            onPaste={index === 0 ? this.handleOtpPaste : undefined}
            ref={(el) => { this.otpRefs[index] = el; }}
            className="otp-digit"
            autoFocus={index === 0}
          />
        ))}
      </div>
    );
  }

  renderMfaSetup() {
    const { emailOtpSent, resendCooldown, mfaLoading } = this.state;
    return (
      <div className="mfa-container">
        <h2>Set Up Two-Factor Authentication</h2>
        <p className="mfa-description">
          Scan the QR code below with your authenticator app
          (e.g., Google Authenticator, Authy), then enter the 6-digit code.
        </p>

        {mfaLoading ? (
          <div className="mfa-loading">
            <Spin size="large" />
            <p>Loading MFA setup...</p>
          </div>
        ) : (
          <>
            <div className="qr-code-wrapper">
              {this.state.qrUrl ? (
                <QRCode value={this.state.qrUrl} size={200} level="M" />
              ) : null}
            </div>

            {this.state.secretKey && (
              <div className="secret-key-section">
                <p className="secret-key-label">Can&apos;t scan? Enter this key manually:</p>
                <div className="secret-key-value">{this.state.secretKey}</div>
              </div>
            )}

            <form onSubmit={this.handleMfaSubmit}>

              {/* Fallback: allow email OTP for users without an authenticator app */}
              <div style={{ textAlign: 'left', marginBottom: '16px', marginTop: '4px' }}>
                <button
                  type="button"
                  className="mfa-email-otp-btn"
                  disabled={emailOtpSent && resendCooldown > 0}
                  onClick={() => this.handleSendEmailOtp()}
                >
                  <i className="fas fa-envelope" style={{ marginRight: '6px' }}></i>
                  {emailOtpSent && resendCooldown > 0
                    ? `OTP sent — resend in ${resendCooldown}s`
                    : emailOtpSent
                    ? 'Resend OTP via Email'
                    : 'Get OTP via Email'}
                </button>
              </div>

              <p className="otp-label">Enter the 6-digit code from your app / email:</p>

              {this.renderOtpInputs()}
              <div className="row" style={{ marginTop: "20px" }}>
                <div className="full-width">
                  <input type="submit" value="Verify & Complete Setup" />
                </div>
              </div>
            </form>
          </>
        )}

        <div className="mfa-back-link">
          <a href="#" onClick={(e) => { e.preventDefault(); this.handleBackToLogin(); }}>
            <i className="fas fa-arrow-left"></i> Back to Login
          </a>
        </div>
      </div>
    );
  }

  renderMfaVerify() {
    const { mfaMethod, emailOtpSent, resendCooldown, mfaLoading } = this.state;
    const isEmail = mfaMethod === 'EMAIL';

    return (
      <div className="mfa-container">
        <h2>Two-Factor Authentication</h2>
        <p className="mfa-description">
          {isEmail
            ? "Enter the 6-digit OTP sent to your registered email address."
            : "Enter the 6-digit code from your authenticator app to continue."}
        </p>

        <div className="mfa-icon">
          <i className={isEmail ? "fas fa-envelope" : "fas fa-shield-alt"}></i>
        </div>

        {/* For QR method — offer Email OTP as alternative */}
        {!isEmail && (
          <div style={{ textAlign: 'left', marginBottom: '20px', marginTop: '20px' }}>
            <button
              type="button"
              className="mfa-email-otp-btn"
              disabled={emailOtpSent && resendCooldown > 0}
              onClick={() => this.handleSendEmailOtp()}
            >
              <i className="fas fa-envelope" style={{ marginRight: '6px' }}></i>
              {emailOtpSent && resendCooldown > 0
                ? `OTP sent — resend in ${resendCooldown}s`
                : emailOtpSent
                ? 'Resend OTP via Email'
                : 'Get OTP via Email'}
            </button>
          </div>
        )}

        <form onSubmit={this.handleMfaSubmit}>
          <p className="otp-label">Verification Code</p>
          {this.renderOtpInputs()}

          {/* Resend button for Email method */}
          {isEmail && (
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <button
                type="button"
                className="mfa-resend-btn"
                disabled={resendCooldown > 0 || mfaLoading}
                onClick={() => this.handleSendEmailOtp()}
              >
                <i className="fas fa-redo" style={{ marginRight: '6px' }}></i>
                {resendCooldown > 0
                  ? `Resend OTP in ${resendCooldown}s`
                  : 'Resend OTP'}
              </button>
            </div>
          )}

          <div className="row" style={{ marginTop: "20px" }}>
            <div className="full-width">
              <input type="submit" value="Verify" />
            </div>
          </div>
        </form>

        <div className="mfa-back-link">
          <a href="#" onClick={(e) => { e.preventDefault(); this.handleBackToLogin(); }}>
            <i className="fas fa-arrow-left"></i> Back to Login
          </a>
        </div>
      </div>
    );
  }

  renderLoginForm() {
    const { email, password } = this.state;
    return (
      <>
        {/* title */}
        <h1>
          <IntlMessages id="login.loginTitle" />
        </h1>
        {/* title ends */}
        {/* logi form */}
        <form>
          <div className="login-form">
            {/* Email */}
            <div className="row">
              <div className="full-width">
                <i className="far fa-envelope"></i>
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={this.handleChange}
                  ref={input => {
                    this.emailInput = input;
                  }}
                />
              </div>
            </div>
            {/* Email ends*/}
            {/* password */}
            <div className="row">
              <div className="full-width">
                <i className="fas fa-lock"></i>
                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            {/* password ends */}
            <div className="row" style={{marginTop:"20px" , marginBottom:"20px"}}>
              <div className="half-width">
                <Checkbox name="remember_me" onChange={this.handleChange}>Remember Me</Checkbox>
              </div>
              <div className="half-width" style={{textAlign:"right"}}>
                <a href="/forgot-password">
                  <IntlMessages id="login.forgotPassword" />
                </a>
              </div>
            </div>
            {/* submit button */}
            <div className="row">
              <div className="full-width">
                <input
                  type="submit"
                  value="Login"
                  onClick={this.handleSubmit}
                />
              </div>
            </div>
            <div className="clear">&nbsp;</div>

            <p>{this.state.loginMessage}</p>
            <p>{/*this.props.loginErrorMessage*/}</p>
            {/* submit button ends */}
          </div>
        </form>
        {/* login form ends */}
      </>
    );
  }

  render() {
    const { submitted, mfaStep, mfaLoading } = this.state;
    const isSpinning = submitted || mfaLoading;

    return (
      <Spin size="large" spinning={isSpinning}>
        <section id="login" className="aligner">
          <div className="wrap1500">
            {/*Login section left side */}
            <div className="login">
              {/* logo */}
              <div className="logo">
                <img src={logo} alt="Logo" />
              </div>
              {/* logo ends */}

              {mfaStep === 'setup' && this.renderMfaSetup()}
              {mfaStep === 'verify' && this.renderMfaVerify()}
              {!mfaStep && this.renderLoginForm()}
            </div>
            {/*login section left side ends */}
            {/* Image area  */}
            <div className="image-area log-imag">
              <img src={LoginImage} alt="login" />
            </div>
            {/* image are ends  */}
          </div>
        </section>
      </Spin>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func,
  mfaSetup: PropTypes.func,
  mfaVerifyOtp: PropTypes.func,
  mfaSendEmailOtp: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  loginErrorMessage: PropTypes.string,
  redirect: PropTypes.string,
  userData: PropTypes.object,
  cleanDivisionsTree: PropTypes.func
};
function mapStateToProps(state) {
  return {
    ...state.user
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...OrgActions }, dispatch);
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true
  })(Login)
);
